<template>
    <div>
      <el-tooltip :content="btnContent" effect="light" placement="top">
        <el-button v-if="isChoosePublicFiles" type="primary" plain @click="handleChoosePubliclibraryFiles">
            <i class="el-icon-upload el-icon--left"></i>
            <template>选择公共文件</template>
        </el-button>
      </el-tooltip>
    <div v-if="!pass && progress !== 0" >
        <el-progress :text-inside="true" :stroke-width="18" :percentage="progress" :status="proStatus"></el-progress>
    </div>
      <el-upload
          v-if="isShowUploadBtn"
          multiple
          ref="uploadObj"
          :action="action"
          :limit="20"
          :auto-upload="true"
          :show-file-list="showFileList || isFromSubForm"
          :file-list="fileList"
          :before-upload="beforeImport"
          :isBPMN="isBPMN"
          :on-exceed="handleExceed"
          :on-preview="handleFile"
          :on-success="handleSuccess"
          :on-change="uploadOnChange"
          :on-progress="uploadOnProgress"
          :on-remove="handleRemove">
          <el-tooltip :content="btnContent" effect="light" placement="top">
            <el-button v-if="isShowUploadBtn" type="primary"  plain>
                <i class="el-icon-upload el-icon--left"></i>
                <template v-if="isBPMN">导入流程</template>
                <template v-else-if="isModelJSON">导入模型</template>
                <template v-else >上传</template>
            </el-button>
          </el-tooltip>
      </el-upload>
      <el-table v-if="(!isShowUploadBtn && !isFormDetail) && !isFromSubForm" :data="fileList" style="width: 100%,height:230px" :border="true" >
          <el-table-column  :show-overflow-tooltip="true" prop="fileName" label="文件名称"></el-table-column>
          <el-table-column  :show-overflow-tooltip="true" prop="createDate" width="130px" label="上传时间"></el-table-column>
          <el-table-column fixed="right"  label="操作" width="130px">
              <template slot-scope="scope">
                  <el-button type="primary" size="mini" icon="el-icon-download" title="下载" circle @click.stop="handleFile(scope.row)"></el-button>
                  <el-button type="success" size="mini" icon="el-icon-view" title="预览" circle @click="handlePreviewFile(scope.row)"></el-button>
                  <br />
                  <el-button type="danger" size="mini" icon="iconfont icon-other-gaizhang" title="盖章" circle @click="handlePrintFile(scope.row)" v-if="scope.row.showSignBtn"></el-button>
                  <el-button type="primary" size="mini" icon="iconfont icon-other-tubiaolunkuo_huaban" title="下载盖章文件" circle @click="downSignFile(scope.row)" v-if="scope.row.showDownSignBtn"></el-button>
                  <el-button type="warning" size="mini" icon="el-icon-s-unfold" title="盖章记录" circle @click="getSignRecord(scope.row)"  v-if="scope.row.showSignBtn"></el-button>
              </template>
          </el-table-column>
      </el-table>
      <el-table v-if="isFormDetail && !isFromSubForm" :data="fileList" style="width: 100%" :border="true" :key="loadTimer">
          <el-table-column  :show-overflow-tooltip="true" prop="fileName" label="文件名称"></el-table-column>
          <el-table-column  :show-overflow-tooltip="true" prop="createDate" width="130px" label="上传时间"></el-table-column>
          <el-table-column fixed="right"  label="操作" width="130px" align="center" >
              <template slot-scope="scope">
                  <el-button type="primary" size="mini" icon="el-icon-download" title="下载" circle @click.stop="downloadFile(scope.row)"  v-if="showDown(scope.row)"></el-button>
                  <el-button type="danger" size="mini" icon="el-icon-delete-solid" title="删除" circle @click.stop="removeFile(scope.row)" v-if="showBtn()"></el-button>
                  <el-button type="success" size="mini" icon="el-icon-view" title="预览" circle @click="previewFile(scope.row)"  v-if="showPrev(scope.row)"></el-button>
                  <br />
                  <el-button type="danger" size="mini" icon="iconfont icon-other-gaizhang" title="盖章" circle @click="handlePrintFile(scope.row)" v-if="scope.row.showSignBtn"></el-button>
                  <el-button type="primary" size="mini" icon="iconfont icon-other-tubiaolunkuo_huaban" title="下载盖章文件" circle @click="downSignFile(scope.row)" v-if="scope.row.showDownSignBtn"></el-button>
                  <el-button type="warning" size="mini" icon="el-icon-s-unfold" title="盖章记录" circle @click="getSignRecord(scope.row)"  v-if="scope.row.showSignBtn"></el-button>
              </template>
          </el-table-column>
      </el-table>
    <el-dialog
            title="选择公用文件"
            top="4vh"
            width="85%"
            :visible.sync="isShowFieldItemArchive"
            append-to-body
        >
        <FieldItemArchive ref="fieldItemArchive" v-if="isShowFieldItemArchive" :isRead="true" :isAvailable="false" :key="loadTimer" :formData="{}" :copyPageList="copySourceList"/>
          <span slot="footer" class="dialog-footer">
              <el-button @click="isShowFieldItemArchive = false">取 消</el-button>
              <el-button type="primary" icon="el-icon-document-copy" @click.stop="handleCopyFileToTarget()">确定</el-button>
          </span>
    </el-dialog>
    <el-dialog
            title="电子签章"
            top="4vh"
            width="85%"
            :visible.sync="isSigin"
            append-to-body
        >
        <Sign></Sign>
    </el-dialog>
    <el-dialog
      title="盖章记录"
      :visible.sync="showFileSignRecord"
      v-if="showFileSignRecord"
      destroy-on-close
      append-to-body
      top="1vh"
      width="80%"
      >
        <SignatureFileRecord :filePath="filePath" v-if="showFileSignRecord"></SignatureFileRecord>
    </el-dialog>
    </div>
</template>

<script>
    import { getPreviewFileUrl } from '@/utils/grocer';
    import { API_FILE_UPLOAD, API_FILE_DOWNLOAD } from '@/common/constants';
    import { downloadFiles, getPubliclibraryFileList, setSignatureRecordParam, getSignatureRecord } from '@/data-model';
    import FieldItemArchive from '@/components/FieldItem/FieldItemArchive';
    import { cloneDeep } from 'lodash';
    import { signUrl } from '@/common/constants/const-global';
    import SignatureFileRecord from '@/pages/system/signatureFileList/signatureFileRecord';
    import { mapGetters } from 'vuex';
    export default {
        components: {
            FieldItemArchive,
            SignatureFileRecord
        },
        data () {
            return {
                uploadFiles: [],
                loadTimer: '',
                copySourceList: [],
                isShowFieldItemArchive: false,
                isSigin: false,
                showFileSignRecord: false,
                filePath: '',
                proStatus: '', // 上传状态
                progress: 0, // 上传进度
                pass: null // 是否上传成功
            };
        },
        watch: {
            // fileList: {
            //     immediate: true,
            //     handler(fileList) {
            //         this.uploadFiles =  [...fileList.map(item => {
            //             item.uid = item.uid || (Date.now() + this.tempIndex++);
            //             item.status = 'success';
            //             return item;
            //         }),...this.uploadFiles.filter(item=>{return item.status=='uploading' || item.status=='ready'})];
            //     }
            // }
        },
        props: {
            fileType: { // 文件上传组件的类型。1:普通文件；2:图片，支持图片预览
                type: Number,
                default: 1
            },
            fileUploadType: {
                type: Array,
                default: () => []
            },
            fileList: {
                type: Array
            },
            showFileList: {
                type: Boolean,
                default: true
            },
            isShowUploadBtn: {
                type: Boolean,
                default: true
            },
            action: {
                type: String,
                default: API_FILE_UPLOAD
            },
            btnContent: {
                type: String,
                default: '一次上传的文件大小总量不超过1000M'
            },
            isBPMN: {// 是否BPMN格式
                type: Boolean,
                default: false
            },
            isModelJSON: {// 是否模型JSON格式
                type: Boolean,
                default: false
            },
            isRead: {
                type: Boolean,
                default: false
            },
            isChoosePublicFiles: {
                type: Boolean,
                default: false
            },
            isFormDetail: {
                type: Boolean,
                default: false
            },
            formBtnAuth: {
                type: Object
            },
            formData: {
                type: Object
            },
            formId: {
                type: String
            },
            isFromSubForm: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters([
                'userInfo'
            ])
        },
        mounted () {
            if (this.isHasAuth()) {
                for (let i = 0; i < this.fileList.length; i++) {
                    let cur = this.fileList[i];
                    let index = cur.filePath.lastIndexOf('.');
                    let fileType = cur.filePath.substr(index);
                    if (fileType === '.pdf' || fileType === '.PDF') { // 是PDF判断当前人是否有权限
                        cur.showSignBtn = true;
                        cur.showDownSignBtn = true;
                        // let res = this.isShowSignBtnState(cur);
                        // // console.log(res);
                        // if (res == true) {
                        //     cur.showDownSignBtn = true;
                        // } else {
                        //     cur.showDownSignBtn = false;
                        // }
                    } else {
                        cur.showSignBtn = false;
                        cur.showDownSignBtn = false;
                    }
                }
            } else {
                for (let i = 0; i < this.fileList.length; i++) {
                    let cur = this.fileList[i];
                    cur.showSignBtn = false;
                    if (cur.createdBy === this.userInfo.userId) {
                        cur.showDownSignBtn = true;
                    }
                }
            }
        },
        created () {
        },
        methods: {
            /** 清理已经上传的文件 */
            _clearUploadFiles () {
                this.$refs.uploadObj.clearFiles();
            },
            isHasAuth () {
                let isEditAuth = false;
                let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                if (currentUserStr) {
                    let currentUserInfo = JSON.parse(currentUserStr);
                    let resources = currentUserInfo.resources;
                    if (resources) {
                        for (let i = 0; i < resources.length; i++) {
                            if (resources[i].resourceUrl === 'electronicSignature') { // 是否可以点击报表进行数据修改
                                isEditAuth = true;
                                break;
                            }
                        }
                    }
                }
                return isEditAuth;
            },
            handleSuccess (response, file, fileList) {
                let isFinish = true;
                for (const index in fileList) {
                    if (fileList[index].status !== 'success') {
                        isFinish = false;
                        break;
                    }
                }
                // 如果没有全部上传完成，忽略本次上次回调
                if (!isFinish) {
                    return;
                }
                this.pass = true;
                if (this.loading) {
                    this.loading.close();
                    this.loading = undefined;
                }
                this.$message.success('上传成功');
                this.$emit('success', { response, file, fileList });
            },
            handleRemove (file, fileList) {
                this.$emit('remove', { file, fileList });
            },
            removeFile (obj) {
                if (this.fileList.length > 0) {
                    for (let i = 0; i < this.fileList.length; i++) {
                        let cur = this.fileList[i];
                        if (cur.uid === obj.uid) {
                            this.fileList.splice(i, 1);
                        }
                    }
                    let fileList = this.fileList;
                    this.$emit('remove', { obj, fileList });
                }
            },
            downloadFile (obj) {
                if (obj.hasOwnProperty('url')) {
                    this.$message.error('未保存的文件不支持下载');
                    return;
                }
                let url = `${API_FILE_DOWNLOAD}${obj.filePath}`;
                this.download(url);
            },
            async downSignFile (row) {
                // 拿到当前文件请求后台查出最新的记录
                let filePath = row.filePath;
                let param = {filePath: filePath};
                let res = await getSignatureRecord(param);
                if (res && res.state === 'success') {
                    if (res.signList && res.signList.length > 0) {
                        let obj = res.signList[0];
                        let url = `${API_FILE_DOWNLOAD}${obj.nowFilePath}`;
                        this.download(url);
                    } else {
                        this.$message.error('文件还没有盖过章');
                    }
                } else {
                    this.$message.error('文件还没有盖过章');
                }
            },
            async handlePrintFile (obj) {
                let url = signUrl;
                obj.formId = this.formId;
                if (this.userInfo.userId) {
                    obj.userId = cloneDeep(this.userInfo.userId);
                    obj.tenantId = cloneDeep(this.userInfo.tenantId);
                }
                // 参数存储到redis
                let res = await setSignatureRecordParam(obj);
                url += '?param=' + res.signId;
                window.open(url);
            },
            async previewFile (obj) {
                if (obj.hasOwnProperty('url')) {
                    this.$message.error('未保存的文件不支持预览');
                    return;
                }
                // let operationType = '&operationType=2';
                let url = `${API_FILE_DOWNLOAD}${obj.filePath}`;
                let index = url.lastIndexOf('.');
                let fileType = url.substr(index);
                if (fileType === '.png' || fileType === '.PNG' ||
                        fileType === '.pdf' || fileType === '.PDF' ||
                        fileType === '.JPG' || fileType === '.jpg' ||
                        fileType === '.JPEG' || fileType === '.jpeg' ||
                        fileType === '.BMP' || fileType === '.bmp' ||
                        fileType === '.GIF' || fileType === '.gif' ||
                        fileType === '.TXT' || fileType === '.txt') {
                    let tempwindow = window.open();
                    url = url + '&operationType=2';
                    tempwindow.location = url;
                } else if (fileType === '.doc' || fileType === '.docx' || fileType === '.xls' || fileType === '.xlsx' || fileType === '.ppt' || fileType === '.pptx') {
                    let previewUrl = await getPreviewFileUrl(obj);
                    if (previewUrl) {
                        let tempwindow = window.open();
                        tempwindow.location = previewUrl;
                    }
                } else {
                    this.$message.error('此格式文件不支持预览');
                }
            },
            handleFile (file) {
                let url = `${API_FILE_DOWNLOAD}${file.filePath}`;
                // let index= url.lastIndexOf(".");
                // let fileType = url.substr(index);
                // if(fileType==='.png'||fileType==='.pdf'||fileType==='.jpg'||fileType==='.jpeg'||fileType==='.bmp'||fileType==='.gif'||fileType==='.txt'){
                //     let tempwindow = window.open();
                //     tempwindow.location = url;
                // }else{
                //     this.download(url);
                // }
                this.download(url);
            },
            handleExceed (files, fileList) {
                this.$message.warning(`每次上传限制10个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            download (url) {
                downloadFiles(url);
                // var iframe = document.createElement('iframe');
                // iframe.style.display = 'none';
                // iframe.src = url;
                // document.body.appendChild(iframe);
            },
            handlePreviewFile (file) {
                // console.log(file);
                this.$emit('previewFile', file);
            },
            beforeImport (file) {
                if (this.isBPMN) {
                    let bpmnExtend1 = '.bpmn';// 文件后缀
                    let bpmnExtend2 = '.bpmn20.xml';// 文件后缀
                    let isBpmnType = file.type === 'text/xml' && (file.name.indexOf(bpmnExtend1) !== -1 || file.name.indexOf(bpmnExtend2) !== -1);
                    if (!isBpmnType) {
                        this.$message.error('请导入以.bpmn或.bpmn20.xml结尾的BPMN xml规范文件!');
                        return false;
                    }
                } else if (this.isModelJSON) {

                }
                console.log(this.fileUploadType);
                if (this.fileUploadType && this.fileUploadType.length > 0) {
                    const fileName = file.name.split('.');
                    const fileExt = fileName[fileName.length - 1] || '';
                    const isTypeOk = this.fileUploadType.map(item => item && item.toUpperCase()).indexOf(fileExt.toUpperCase()) >= 0;
                    if (!isTypeOk) {
                        this.$message.error(`文件格式不正确, 请上传${this.fileUploadType.join('/')}格式文件!`);
                        return false;
                    }
                }
                let isLt350M = (file.size / 1024 / 1024 < 3096);
                if (!isLt350M) {
                    this.$message.error('上传文件大小不能超过 3G!');
                    return false;
                }
                return true;
            },
            async handleChoosePubliclibraryFiles () {
                let fileTree = await getPubliclibraryFileList();
                this.copySourceList = fileTree;
                this.isShowFieldItemArchive = true;
            },
            handleCopyFileToTarget () {
                let targetMultipleSelection = this.$refs.fieldItemArchive.getTargetFiles();
                // console.log(this.multipleSelection);
                if (targetMultipleSelection.length === 0) {
                    this.$message({message: '请勾选要复制的文件', type: 'warning'});
                } else {
                    let targetFiles = [];
                    for (let i = 0; i < targetMultipleSelection.length; i++) {
                        let selected = targetMultipleSelection[i];
                        if (selected.dir === false && !this.existsInFileList(selected)) {
                            targetFiles.push(cloneDeep(selected));
                        }
                    }
                    if (targetFiles.length > 0) {
                        this.$emit('publicLiberyChoosedSuccess', targetFiles, this.fileList);
                    }
                    this.isShowFieldItemArchive = false;
                }
            },
            existsInFileList (file) {
                let res = false;
                if (this.fileList && this.fileList.length > 0) {
                    for (let i = 0; i < this.fileList.length; i++) {
                        if (this.fileList[i].filePath === file.filePath) {
                            res = true;
                            break;
                        }
                    }
                }
                return res;
            },
            showBtn () {
                if (this.formBtnAuth) {
                    return this.formBtnAuth.isShowDelete;
                } else {
                    return true;
                }
            },
            showDown (obj) {
                let isEditAuth = false;
                if (!obj.createdBy) {
                    isEditAuth = true;
                    return isEditAuth;
                } else {
                    let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                    let currentUserInfo = JSON.parse(currentUserStr);
                    if (currentUserInfo.userId == obj.createdBy) {
                        isEditAuth = true;
                        return isEditAuth;
                    } else {
                        if (currentUserInfo) {
                            let resources = currentUserInfo.resources;
                            if (resources) {
                                for (let i = 0; i < resources.length; i++) {
                                    if (resources[i].resourceUrl === 'formFileDownload') { // 是否可以点击报表进行数据修改
                                        isEditAuth = true;
                                        return isEditAuth;
                                        // break;
                                    }
                                }
                            }
                        }
                    }
                }
                return isEditAuth;
            },
            showPrev (obj) {
                let isEditAuth = false;
                if (!obj.createdBy) {
                    isEditAuth = true;
                } else {
                    let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                    let currentUserInfo = JSON.parse(currentUserStr);
                    if (currentUserInfo.userId === obj.createdBy) {
                        isEditAuth = true;
                    } else {
                        if (currentUserInfo) {
                            let resources = currentUserInfo.resources;
                            if (resources) {
                                for (let i = 0; i < resources.length; i++) {
                                    if (resources[i].resourceUrl === 'formFilePreview') { // 是否可以点击报表进行数据修改
                                        isEditAuth = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                return isEditAuth;
            },
            async isShowSignBtnState (row) {
                let filePath = row.filePath;
                let param = {filePath: filePath};
                let res = await getSignatureRecord(param);
                if (res && res.state === 'success') {
                    if (res.signList && res.signList.length > 0) {
                        let obj = res.signList[res.signList.length - 1];
                        row.nowFileName = obj.nowFileName;
                        row.nowFilePath = obj.nowFilePath;
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            getSignRecord (obj) {
                this.filePath = obj.filePath;
                this.showFileSignRecord = true;
            },
            uploadOnChange (file) {
                if (file.status === 'ready') {
                    // console.log("ready")
                    this.pass = undefined;
                    this.progress = 0;
                } else if (file.status === 'fail') {
                    this.$message.error('文件上传出错，请刷新重试！');
                }
            },
            uploadOnProgress (e, file) { // 开始上传
                // console.log(e.percent,file)
                this.loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.progress = Math.floor(e.percent);
                if (this.progress > 0 && this.progress < 100) {
                    this.proStatus = 'exception';
                } else if (this.progress === 100) {
                    this.proStatus = 'success';
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/FileUpload/FileUpload.vue